module.exports = __webpack_public_path__ + "static/media/capture.cc52c506.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gifshop/capture.jpg
// module id = 236
// module chunks = 0